import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { CustomSwitch } from "../../app/router/CustomSwitch";
import { Routes } from "../../app/router/Routes";
import { ApplicantInformationContainer } from "../sites/ApplicantInformationContainerSite";
import { DashboardSite } from "../sites/DashboardSite";
import { EvidenceSite } from "../sites/EvidenceSite";
import { RejectedSite } from "../sites/RejectedSite";
import { HrRoutes } from "./HrRoutes";

export const HrRouter = observer(() => (
    <CustomSwitch>
        <Route exact path={Routes.HR}>
            <Redirect to={HrRoutes.DASHBOARD} />
        </Route>
        <Route path={HrRoutes.DASHBOARD} component={DashboardSite} />
        <Route path={HrRoutes.EVIDENCE} component={EvidenceSite} />
        <Route path={HrRoutes.REJECTED} component={RejectedSite} />
        <Route path={HrRoutes.APPLICANT.ROOT} component={ApplicantInformationContainer} />
    </CustomSwitch>
));
